import { useEffect } from "react";
import PageSpinner from "components/PageSpinner";
import axiosConfig from "config/axios";
import requestErrorHandler from "util/requestErrorHandler";
import { useLocation } from "@reach/router";
import { parse } from "fast-qs";
import { message } from "antd";
import { navigate } from "@reach/router";


export default function ApproveAddressChange(props: ReachPathProps) {
  const { search } = useLocation();

  const { token } =
    parse(search) as {
      token: string;
    };

  useEffect(() => {
    if (!token) {
      requestErrorHandler(
        new Error("Token is required to approve address change")
      );
      return;
    }
    axiosConfig.post(
        `${process.env.REACT_APP_BACKEND_URL}/supplier/address-change/approve/?token=${token}`,
    )
    .then((response) => {
      console.log("Address change approved", response.data);
      message.success(response.data.message || "Address change approved successfully");
      setTimeout(() => {
        navigate("/login");
      }, 4000);
    })
    .catch((error) => {
      requestErrorHandler(error);
      setTimeout(() => {
        navigate("/login");
      }, 4000);
    });
  }, [token]);

    return (<PageSpinner fullScreen />);
}